import type { StatusColor } from '@uiKit/components/StatusBadge.vue'
import { REFUND_STATE, type RefundState } from '../types/refundsTypes'

const STATE_COLOR: Record<RefundState, StatusColor> = {
  [REFUND_STATE.PENDING]: 'warning',
  [REFUND_STATE.APPROVED]: 'info',
  [REFUND_STATE.SETTLED]: 'success',
  [REFUND_STATE.REJECTED]: 'danger',
}

const STATE_LABEL: Record<RefundState, string> = {
  [REFUND_STATE.PENDING]: 'Pending',
  [REFUND_STATE.APPROVED]: 'Approved',
  [REFUND_STATE.SETTLED]: 'Settled',
  [REFUND_STATE.REJECTED]: 'Rejected',
}

export function getRefundStateColor(state: RefundState): StatusColor {
  return STATE_COLOR[state] ?? 'neutral'
}

export function getRefundStateLabel(state: RefundState): string {
  return STATE_LABEL[state] ?? state
}

export function getRefundMethodLabel(method: string): string {
  if (method === 'fiat_wallet') return 'Wallet credit'
  if (method === 'payment_gateway') return 'Payment gateway'
  return method
}
